module.exports = function() {
  return new Worker(__webpack_public_path__ + "6814feafa9271a11959e.worker.js");
};